/**
 * IndexedDB-backed storage adapter for Zustand persist middleware.
 *
 * On iOS Safari, localStorage is frequently purged when the browser is
 * force-closed or when the OS reclaims storage.  IndexedDB is far more
 * durable and survives browser restarts reliably.
 *
 * Usage:
 *   persist(fn, { name: 'key', storage: idbStorage })
 */

import { get, set, del } from 'idb-keyval';
import type { StateStorage } from 'zustand/middleware';

export const idbStorage: StateStorage = {
  getItem: async (name: string): Promise<string | null> => {
    const value = await get(name);
    return (value as string) ?? null;
  },
  setItem: async (name: string, value: string): Promise<void> => {
    await set(name, value);
  },
  removeItem: async (name: string): Promise<void> => {
    await del(name);
  },
};
